class ExistsNumberTopBarCtrl {
    [x: string]: any;

    getTranslate() {
        return this.hasNumbers ? 'ORDER_NUMBER.USE_EXISTING' :'ORDER_NUMBER.USE_EXISTING_NO_NUMBERS'
    }
}

export default {
    controller: ExistsNumberTopBarCtrl,
    template : require('./exists.number.top.bar.html'),
    bindings: {
        hasNumbers: '<'
    }
}
